export enum EOutputType {
    Vessel = 'Vessel', //1
    Fleet = 'Fleet', //1< <=200
    Summary = 'Summary', //200+
    None = 'None' // No vessel found
}

export enum ESelectionType {
    Port = 'Port',
    Vessel = 'Vessel',
    Filter = 'Filter',
    Portfolio = 'Portfolio',
    Ownership = 'Ownership',
    Sector = 'Sector',
    DraftFilter = 'DraftFilter',
    DraftPortfolio = 'DraftPortfolio',
    None = 'None' // maybe not necessary
}

export enum ESubscriptionLevelType {
    Gold = 'Gold',
    Silver = 'Silver',
    Bronze = 'Bronze',
}

export enum ESubscriptionType {
    Seascape = 'Seascape'
}